/**
 * This function will handle url related stuff
 *
 * @returns {Object} - object containing methods related to url
 */
const router = () => {
    /**
     * This function updates the url without loading the page
     *
     * @param {string} path - path to update in url
     * @param {string} dataAction The data action of the page
     * @param {string} id The id of an object to be stored in the history
     * @returns {undefined}
     */
    const push = (path, dataAction, id) => window.history.pushState({page: path, action: dataAction, id: id}, '', path);

    return {push};
};

export default router();
